import $ from 'jquery';

$(document).ready(function(){

  $('.usps--product').owlCarousel({
    center: false,
    items: 2,
    loop: true,
    margin: 60,
    dots: false,
    autoWidth: false,
    autoplay: true,
    nav: false,
    responsive: {
      768 : {
          center: false,
          items: 3,
          margin:30,
          loop: false,
          autoplay: false,
      }
    }
  });

  $('.topbar__slider').owlCarousel({
    center: false,
    items: 1,
    loop: true,
    dots: false,
    autoWidth: false,
    nav: false,
    autoplay: true,
    autoplayTimeout: 7000,
  });

  $('.hero').owlCarousel({
    center: true,
    items: 1,
    loop: true,
    dots: false,
    autoWidth: false,
    nav: false,
    autoplay: true,
    autoplayTimeout: 10000,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    mouseDrag: false,
    dots: true
  });

  $('.featured-products--creative').owlCarousel({
    center: true,
    items: 2,
    loop:true,
    margin: 15,
    dots: true,
    autoWidth: false,
    autoplay: false,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    responsive: {
      768 : {
          items: 6,
          margin:30,
      }
    }
  });

  $('.featured-products--default').owlCarousel({
    center: false,
    items: 2,
    loop: false,
    margin: 15,
    dots: true,
    autoWidth: false,
    autoplay: false,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    responsive: {
      768 : {
          items: 5,
          margin:30,
          center: false
      }
    }
  });

  $('.gallery-images:not(.gallery-images--partners)').owlCarousel({
    center: false,
    items: 5,
    loop:true,
    margin: 0,
    dots: false,
    autoWidth: false,
    autoplay: true,
  });

  $('.gallery-images--partners').owlCarousel({
    center: true,
    items: 2,
    loop:true,
    margin: 20,
    dots: true,
    autoWidth: false,
    autoplay: true,
    responsive: {
      768 : {
          items: 5,
          margin:40,
          center: false
      }
    }
  });

  $('.woo-variation-gallery-thumbnail-slider').slick('slickSetOption', 'slidesToShow', 2, true);

  $('.videos--slider').owlCarousel({
    center: false,
    items: 4,
    loop: false,
    margin:30,
    dots: false,
    autoWidth: false,
    autoplay: false,
    nav: true,
    navText: ['<i class="icon icon-angle-left"></i>', '<i class="icon icon-angle-right"></i>'],
  });

  $('.featured-categories').owlCarousel({
    center: true,
    items: 2,
    loop: true,
    margin: 15,
    dots: true,
    autoWidth: false,
    autoplay: true,
    nav: false,
    responsive: {
      576 : {
          center: false,
          items: 4,
          loop: false,
          nav: false,
          margin: 30
      }
    }
  });

  $('.blogs:not(.blogs--default)').owlCarousel({
    center: false,
    items: 2,
    loop: false,
    margin: 15,
    dots: true,
    autoWidth: false,
    autoplay: true,
    nav: false,
    responsive: {
      576 : {
          center: false,
          items: 4,
          loop: false,
          nav: false,
          margin: 30
      }
    }
  });

  // var blog_owl = $('.blogs__filter').owlCarousel({
  //   margin: 12,
  //   center: true,
  //   loop: false,
  //   autoWidth: true,
  //   items: 1,
  //   nav: true,
  //   dots: false,
  //   navText: ['<i class="icon icon-angle-left"></i>', '<i class="icon icon-angle-right"></i>'],
  // });

});